import {
  API_BASE_URL,
  ADD_COMMENT,
  DELETE_COMMENT,
  LIST_COMMENTS,
  COUNT_COMMENTS
} from "./constants";
import { API, createTextHeaders } from "app/api";

export const createComment = params => {
  const { resourceType, resourceId, comment: body } = params;
  const url = `${API_BASE_URL}/comments/${resourceType}/${resourceId}`;
  const headers = createTextHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...ADD_COMMENT
    }
  };
};

export const deleteComment = params => {
  const { resourceType, resourceId, commentSlug } = params;
  const url = `${API_BASE_URL}/comments/${resourceType}/${resourceId}/${commentSlug}`;
  const request = new Request(url, {
    method: "DELETE",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...DELETE_COMMENT
    }
  };
};

export const listComments = params => {
  const { resourceType, resourceId } = params;
  const url = `${API_BASE_URL}/comments/${resourceType}/${resourceId}`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...LIST_COMMENTS
    }
  };
};

export const countComments = params => {
  const { resourceType, resourceId } = params;
  const url = `${API_BASE_URL}/count/comments/${resourceType}/${resourceId}`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...COUNT_COMMENTS
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/comments/actions.js